import React from 'react';
import '../../css/footer.css';

export const Footer = () => (
  <footer className="border-top mt-5 py-4 footer-panel">
    <div className="container text-center">
      <p className="mb-0 footer-text">Operate Explorer © 2025</p>
    </div>
  </footer>
);
